// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__EDLru","not_arrow":"Popup_not_arrow__861rg","triangle":"Popup_triangle__UDYH1"};